import React from 'react';
import Header from 'components/util/cabecario/.mixins';
import { Helmet } from 'react-helmet';
import { useHelmet } from 'hooks';

export const TopBar = () => {
  useHelmet({ title: ` ${process.env.REACT_APP_TITLE} - Formulários` });

  return (
    <>
      <Helmet>
        <title>{`${process.env.REACT_APP_TITLE} - Formulários`}</title>
      </Helmet>
      <Header title="Formulários" />
    </>
  );
};
